<p-toast position="top-right" []></p-toast>
<router-outlet></router-outlet>

@if (authService.isSigningIn()) {
  <app-interactive-loader
    [title]="'Signing you in'"
    [stages]="authService.signingInStages"
    [stageText]="authService.signingInStageText()"
    [rows]="4"
    [rowVariant]="'rich'"
    [overlay]="true"
    [lockScroll]="true">
  </app-interactive-loader>
}

@if (pdfExportService.isExporting()) {
  <app-interactive-loader
    [title]="pdfExportService.loaderTitle()"
    [stages]="pdfExportService.loaderStages()"
    [stageText]="pdfExportService.loaderStageText()"
    [rows]="4"
    [rowVariant]="'rich'"
    [overlay]="true"
    [lockScroll]="true"
    [showProgress]="pdfExportService.showProgress()"
    [progressPart]="pdfExportService.progressPart()"
    [progressTotal]="pdfExportService.progressTotal()">
  </app-interactive-loader>
}
